import { render, staticRenderFns } from "./PlacesChosenWidget.vue?vue&type=template&id=517f17e8&"
import script from "./PlacesChosenWidget.vue?vue&type=script&lang=js&"
export * from "./PlacesChosenWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('517f17e8')) {
      api.createRecord('517f17e8', component.options)
    } else {
      api.reload('517f17e8', component.options)
    }
    module.hot.accept("./PlacesChosenWidget.vue?vue&type=template&id=517f17e8&", function () {
      api.rerender('517f17e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/widgets/feeds/PlacesChosenWidget.vue"
export default component.exports